var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareQ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.411,
    height: 17.411,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#3b5175;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.661 8.706A7.956 7.956 0 0 0 1.442 5.461M1.155 2.316v3.485M4.64 5.801H1.155M15.969 11.95A7.956 7.956 0 0 1 .75 8.706M16.256 15.095V11.61M12.772 11.61h3.485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareQ);
export default __webpack_public_path__ + "static/media/share_q.50852308639f4c4d8a7645edd9f67e1b.svg";
export { ForwardRef as ReactComponent };